import { Formats } from "@portal/hooks/use-formats";
import { PaymentList } from "@portal/types/entities/payment";
import { GridColumnProps } from "@sinecycle/growcomponents";
import { useMemo } from "react";
import { getPaymentModeLabel, getPaymentStatus } from "../predicate";
import { AssociatedInvoices } from "./AssociatedInvoices/AssociatedInvoices";
import { ReferenceCell } from "./Reference/ReferenceCell";

function useColumns(extra: Formats) {
  function handleColumns() {
    const columns: GridColumnProps<PaymentList> = [
      {
        colId: "DEFAULT",
        headerName: "Reference #",
        cellRenderer: ReferenceCell,
        pinned: "left",
      },

      {
        colId: "PAYMENT_DATE",
        headerName: "Payment Date",
        field: "date",
        cellRenderer: "dateCell",
        sortable: true,
        cellRendererParams: {
          dateCellProps: {
            format: extra.dateformat,
          },
        },
      },

      {
        colId: "AMOUNT",
        headerName: "Amount",
        cellRenderer: "amountCell",
        field: "amount",
        cellClass: "ag-right-aligned-cell",
        headerClass: "ag-right-aligned-header",
        cellRendererParams: {
          amountTextProps: {
            locale: extra.locale,
          },
        },
        valueGetter: (data) => {
          return { amount: data.data?.amount, currency: data.data?.currency };
        },
      },
      {
        colId: "INVOICE",

        headerName: "Associated Invoice(s)",

        cellRenderer: AssociatedInvoices,
      },
      {
        colId: "MODE",

        headerName: "Payment Mode",
        field: "mode",
        cellRenderer: "textCell",
        cellRendererParams: {
          textCellProps: {
            ellipsis: {
              tooltip: {
                placement: "top",
              },
            },
          },
        },
        valueGetter: (params) => {
          return getPaymentModeLabel(params.data?.mode)?.label;
        },
      },
      {
        colId: "STATUS",
        headerName: "Payment Status",
        cellRenderer: "statusCell",
        field: "status",
        cellRendererParams: {
          statusCellProps: {
            getter: getPaymentStatus,
          },
        },
      },
    ];
    return columns;
  }

  const defaultColConfigs = useMemo(handleColumns, [
    extra.dateformat,
    extra.locale,
  ]);

  return { defaultColConfigs };
}

export { useColumns };
